  <!-- Modern Categories Page -->
<div class="categories-page">
  <div class="breadcrumb-wrapper">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>
  
  <!-- Page Header Section -->
  <div class="page-header-section">
    <div class="container">
      <h1 class="page-title">Shop by Category</h1>
      <p class="page-subtitle">Discover our wide range of product categories</p>
    </div>
  </div>

  <!-- Category Navigation Header with Search -->
  <div class="category-nav-header">
    <div class="container">
      <div class="category-nav-wrapper">
        <!-- Categories on left, search on right -->
        <div class="category-links">
          <a href="/home" class="nav-link">Home</a>
          <ng-container *ngFor="let item of productDetails">
            <a 
              (click)="navigateToViewProduct(item?._id, item?.categoryName)" 
              class="nav-link" 
              style="cursor: pointer;"
              *ngIf="item?.categoryName?.toLowerCase().includes('electronics') || item?.categoryName?.toLowerCase().includes('beauty') || item?.categoryName?.toLowerCase().includes('baby') || item?.categoryName?.toLowerCase().includes('home decor')">
              {{ item?.categoryName === 'Home Decor Products' ? 'Home Decor' : item?.categoryName }}
            </a>
          </ng-container>
          <div class="see-more-dropdown" (clickOutside)="closeDropdown()">
            <button class="see-more-btn" (click)="toggleDropdown(); $event.stopPropagation()">
              See More
              <i class="fa fa-chevron-down" [class.rotate]="isDropdownOpen"></i>
            </button>
            <div class="dropdown-content" [class.show]="isDropdownOpen">
              <ng-container *ngFor="let item of productDetails">
                <a 
                  (click)="navigateToViewProduct(item?._id, item?.categoryName)" 
                  class="dropdown-link" 
                  style="cursor: pointer;"
                  *ngIf="!item?.categoryName?.toLowerCase().includes('electronics') && !item?.categoryName?.toLowerCase().includes('beauty') && !item?.categoryName?.toLowerCase().includes('baby') && !item?.categoryName?.toLowerCase().includes('home decor')">
                  {{ item?.categoryName === 'Home Decor Products' ? 'Home Decor' : item?.categoryName }}
                </a>
              </ng-container>
            </div>
          </div>
        </div>
        
        <!-- Search Bar -->
        <div class="search-section-inline">
          <div class="search-wrapper">
            <i class="fa fa-search search-icon"></i>
            <input
              type="text"
              class="search-input"
              [(ngModel)]="serviceName"
              placeholder="Search categories..."
              (input)="getServiceList(); currentPage = 1"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Categories Grid -->
  <div class="categories-grid-section">
    <div class="container">
      <!-- Loading State with Shimmer -->
      <ng-container *ngIf="!productDetails?.length && !isLoading">
        <div class="categories-grid">
          <div class="category-card shimmer-card" *ngFor="let item of length(12)">
            <div class="card-image">
              <ngx-skeleton-loader
                [theme]="{
                  height: '200px',
                  width: '100%',
                  'border-radius': '16px'
                }"
                count="1"
              ></ngx-skeleton-loader>
            </div>
            <div class="card-title">
              <ngx-skeleton-loader
                [theme]="{
                  height: '20px',
                  width: '80%',
                  'border-radius': '4px'
                }"
                count="1"
              ></ngx-skeleton-loader>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Category Cards -->
      <ng-container *ngIf="productDetails?.length">
        <div class="categories-grid">
          <div
            class="category-card"
            *ngFor="
              let item of productDetails
                | paginate
                  : {
                      itemsPerPage: pageSize,
                      currentPage: currentPage,
                      totalItems: totalItems
                    };
              let i = index
            "
            (click)="navigateToViewProduct(item?._id, item?.categoryName)"
          >
            <div class="card-image">
              <img 
                [src]="item?.categoryImage" 
                [alt]="item?.categoryName"
                (error)="$event.target.src='assets/images/placeholder.png'"
              />
              <div class="card-overlay">
                <span class="view-text">View Products</span>
              </div>
            </div>
            <div class="card-content">
              <h3 class="card-title">{{ item?.categoryName }}</h3>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- No Data State -->
      <div *ngIf="isLoading && !productDetails?.length" class="no-data-state">
        <div class="no-data-content">
          <i class="fa fa-folder-open"></i>
          <h3>No Categories Found</h3>
          <p>Try adjusting your search or browse all categories</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-section" *ngIf="totalItems > pageSize">
    <div class="container">
      <div class="pagination-wrapper">
        <button 
          class="pagination-btn prev-btn" 
          [disabled]="currentPage === 1"
          (click)="goToPage(currentPage - 1)">
          <i class="fa fa-chevron-left"></i>
          Previous
        </button>
        
        <div class="pagination-numbers">
          <button 
            *ngFor="let page of getPageNumbers()" 
            class="pagination-btn page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{ page }}
          </button>
        </div>
        
        <button 
          class="pagination-btn next-btn" 
          [disabled]="currentPage === getTotalPages()"
          (click)="goToPage(currentPage + 1)">
          Next
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
      <div class="pagination-info">
        Showing {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} categories
      </div>
    </div>
  </div>
</div>